import Api from './api';
class HttpUtils {
    get(url,isToken) {

      let token=  "";
      if(isToken != false){
        token=  Api.auth_tokenManager();
        if(!token){
          return ;
        }
      }
     
    
      return new Promise((resolve, reject) => {
        fetch(url, {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "x-auth-token": token
          }
        })
        .then((response) => {
					if (response.ok == false) reject(response);
					else return response.json();
			  })
        .then(response =>{
          if(response.status || response.status == 422){
            alert(response.errorMessage);
            reject(response);
          }else if(response.status >= 400 && response.status < 500){
            alert(response.errorMessage);
            reject(response);
          }else{
            resolve(response)
          }
        })
        .catch(err => reject(err))
      })
    }
    // post方式
    post(url, data,isToken) {
      let token = '';
      if(isToken != false){
        token = Api.auth_tokenManager();
        if(!token){
          return ;
        }
      }
      let headersParam = {
        Accept: "application/json",
        "Content-Type": "application/json",
      };

      if(isToken != false){
        headersParam["x-auth-token"] = token;
      }
     
      return new Promise((resolve, reject) => {
        fetch(url, {
            method: 'POST',
            headers: headersParam,
            body: JSON.stringify(data)
          })
          // .then((response) => {
          //   if (response.ok == false) reject(response);
          //   else return response.json();
          // })

          .then(checkStatus)
          .then(parseJSON)
          .then(response =>{
            if(response.errorCode || response.errorCode == 422){
              alert(response.errorMessage);
              reject(response);
            }else if(response.status >= 400 && response.status < 500){
              alert(response.errorMessage);
              reject(response);
            }else{
              resolve(response)
            }
          })
          .catch(err => {
            reject(err)
          })
  
      })
    }


  httpPost(uri, params,isToken) {
      let token = '';
      if(isToken != false){
        token = Api.auth_tokenManager();
        if(!token){
          return ;
        }
      }

      let headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      };

      if(isToken != false){
        headers["x-auth-token"] = token;
      }

      let init = {
          method: 'POST',
          credentials: 'include',
          headers: headers,
          body: JSON.stringify(params)
      };
      
      return new Promise(function (resolve, reject) {
          fetch(uri, init)
              .then(checkStatus)
              .then(parseJSON)
              .then(data => {
                  if (!data) return;
                  if (data.status === 0) {
                      resolve(data.data);
                  } else {
                      reject(data);
                  }
              }).catch(function (ex) {
                  reject(ex, '服务器错误');
              });
      });
  }
  
    //put 修改
    put(url, data) {
      let token=  Api.auth_tokenManager();
      if(!token){
        return ;
      }
      return new Promise((resolve, reject) => {
        fetch(url, {
            method: 'PUT',
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              "x-auth-token": token
            },
            body: JSON.stringify(data)
          })
          .then((response) => {
            if (response.ok == false) reject(response);
            else return response.json();
          })
          .then(data => resolve(data))
          .catch(err => reject(err))
  
      })
    }
  
    //delete
    delete(url, data) {
      return new Promise((resolve, reject) => {
        let token=  Api.auth_tokenManager();
        if(!token){
          return ;
        }
        fetch(url, {
            method: 'DELETE',
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              "x-auth-token": token
            },
            body: JSON.stringify(data)
          })
          .then(res => res.json())
          .then(data => resolve(data))
          .catch(err => reject(err))
      })
    }
  }
  
  
  const requestFun = new HttpUtils(); //new生成实例
  export const { get, post, put } = requestFun;
  export default requestFun;

 
// 处理请求状态status
function checkStatus(response) {
    if (response.status >= 200 && response.status < 300) {
        return response
    } else {
        try {
          var error = new Error(response.statusText)
          error.response = response
          throw error
        } catch (error) {
          return new Promise((resolve, reject) => {
            resolve(error);
          })
        }
    }
}
 
// 处理请求结果response
function parseJSON(response) {
    return response.json().then((res) => {
        return new Promise((resolve, reject) => {
            resolve(res);
        })
    }).catch(err => {
      return new Promise((resolve, reject) => {
        resolve('DATA_IS_EMPTY');
      })
        console.log(err,'服务器返回错误');
    });
}










// WEBPACK FOOTER //
// ./src/utils/http.js